import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTheme } from '@mui/material';
import { tokens } from '../../theme';
import logger from '../../utils/logger';

export default function EpisodeTabNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const episodeOfCare = location.state?.episodeOfCare;
  const [value, setValue] = useState(0);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    switch (location.pathname) {
      case '/patient/episode/dashboard':
        setValue(0);
        break;
      case '/patient/episode/tms_treatment_plans':
        setValue(1);
        break;
      case '/patient/episode/tms_treatment_sessions':
        setValue(2);
        break;
      case '/patient/episode/test_scores':
        setValue(3);
        break;
      case '/patient/episode/medications':
        setValue(4);
        break;
      case '/patient/episode/diagnosis':
        setValue(5);
        break;
      default:
        setValue(0);
    }
  }, [location.pathname]);

  //logger.info(`EpisodeTabNavigation value is ${value}`);

  const handleChange = (event, newValue) => {
    setValue(newValue); // Update the value state here
    let route = '/';
    switch (newValue) {
      case 0:
        route = '/patient/episode/dashboard';
        break;
      case 1:
        route = '/patient/episode/tms_treatment_plans';
        break;
      case 2:
        route = '/patient/episode/tms_treatment_sessions';
        break;
      case 3:
        route = '/patient/episode/test_scores';
        break;
      case 4:
        route = '/patient/episode/medications';
        break;
      case 5:
        route = '/patient/episode/diagnosis';
        break;
      default:
        route = '/patient/episodes';
        break;
    }
    navigate(route, { state: { episodeOfCare } });
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        centered
        variant='fullWidth'
        sx={{
          backgroundColor: colors.primary[400],
          '& .MuiTab-root.Mui-selected': {
            color: colors.greenAccent[400],
          },
          '& .MuiTabs-indicator': {
            backgroundColor: colors.greenAccent[400],
          },
        }}
      >
        <Tab label='DASHBOARD' />
        <Tab label='TREATMENTS' />
        {/* <Tab label='TREATMENT SESSIONS' /> */}
        <Tab label='TEST SCORES' />
        <Tab label='MEDICATION HISTORY' />
        <Tab label='DIAGNOSIS HISTORY' />
      </Tabs>
    </Box>
  );
}
